<template>
  <div class="container">
    <HeadingOne class="-margin-md">お申し込み完了</HeadingOne>

    <WizardGroup class="-margin-md">
      <MainWizard :active-index="3" type="entry"></MainWizard>
    </WizardGroup>

    <StepPage class="-success">
      <StepHeader class="complete">
        <img
          src="@/assets/images/icons/check-ok.svg"
          class="_i-w-sm-37 _i-w-md-74 _mb-sm-15 _mb-md-30"
          alt=""
        />
        <h2 class="heading">お申し込みが完了しました。</h2>
        <p class="_mb-0">
          このたびはお申し込みいただき誠にありがとうございました。
        </p>
        <small class="complete-note"
          >※ 下記電話番号よりお電話を差し上げることがございます。<br />･ご入力された情報に不備があった場合<br />･当社がお客さまに確認が必要と判断した場合</small
        >
      </StepHeader>
      <TelBox></TelBox>
      <StepBody>
        <StepList type="tem" class="-orange">
          <HeadingIcon class="-bold _mb-30">
            <IconBox src="note" class="-w30 _mr-sm-5 _mr-md-10"></IconBox>
            <h3 class="heading">ご利用までの流れについて</h3>
          </HeadingIcon>
          <StepItem
            number="1"
            title="審査完了をメールでご連絡(最短30分※)"
            src="page/tem001/step1.gif"
            class="-sm"
          >
            <p>
              審査完了次第、ご登録いただいたメールアドレスに「審査完了のお知らせ【au
              PAY スマートローン】」の件名で審査結果をご案内します。
            </p>
            <small
              >※お申し込みの時間帯や審査状況によっては、翌日以降のご連絡となる場合がございます。</small
            >
          </StepItem>
          <StepItem
            number="2"
            title="審査結果確認～ご契約手続き"
            src="page/tem001/step3.gif"
            class="-last -sm"
          >
            <p>
              メールに記載されているURLより審査結果ご確認ページへアクセスしてください。
            </p>
            <p>
              審査結果確認後、ご利用可能なお客さまはそのままご契約手続きとなります。
            </p>
            <small
              >※本サイトのトップページからも審査結果をご確認いただけます。</small
            >
          </StepItem>
          <StepFooter>
            <template #heading>サービスご利用開始</template>
            <template #text>
              <p class="_mt-15">ご契約締結後、すぐにお借り入れが可能です。</p>
              <p>
                お借り入れ方法について詳しくは<BtnText
                  router-name="sv046"
                  class="-underline"
                  >こちら</BtnText
                >
              </p>
            </template>
          </StepFooter>
        </StepList>
      </StepBody>
    </StepPage>

    <ListGroup class="-note _mt-20">
      <ListItem class="-note"
        >お申し込み内容により、お手続きにお時間がかかる場合や、ご希望に添えない場合がございます。</ListItem
      >
      <ListItem class="-note"
        >お申し込み内容や在職確認等のため、お電話させていただく場合がございます。</ListItem
      >
    </ListGroup>

    <BtngroupSingle class="-margin-lg">
      <BtnMain class="-normal -md" router-name="sv001">
        au PAY スマートローントップへ
      </BtnMain>
    </BtngroupSingle>
  </div>
</template>

<script>
import { setMeta } from "@/utils/Meta";
import HeadingOne from "@/components/heading/HeadingOne";
import WizardGroup from "@/components/wizard/WizardGroup";
import MainWizard from "@/components/wizard/MainWizard";
import StepPage from "@/components/steps/StepPage";
import StepHeader from "@/components/steps/StepHeader";
import StepBody from "@/components/steps/StepBody";
import StepList from "@/components/steps/StepList";
import HeadingIcon from "@/components/heading/HeadingIcon";
import IconBox from "@/components/icons/IconBox";
import StepItem from "@/components/steps/StepItem";
import StepFooter from "@/components/steps/StepFooter";
import ListGroup from "@/components/list/ListGroup";
import ListItem from "@/components/list/ListItem";
import BtngroupSingle from "@/components/button/BtngroupSingle";
import BtnMain from "@/components/button/BtnMain";
import BtnText from "@/components/button/BtnText";
import TelBox from "@/components/box/TelBox";
export default {
  name: "Tem006",
  components: {
    BtnText,
    BtnMain,
    BtngroupSingle,
    ListItem,
    ListGroup,
    StepFooter,
    StepItem,
    IconBox,
    HeadingIcon,
    StepList,
    StepBody,
    StepHeader,
    StepPage,
    MainWizard,
    WizardGroup,
    HeadingOne,
    TelBox,
  },
  setup() {
    setMeta({
      title: "お申し込み完了",
      description:
        "au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。",
      keywords:
        "au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,入会,お申し込み",
    });
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";

.steps-header.complete {
  padding-bottom: 13px;
}

small.complete-note {
  display: block;
  text-align: left;
  @include mq-down(md) {
    margin-top: 10px;
    margin-bottom: 0;
    line-height: 20px;
  }
  @include mq-up(md) {
    margin-top: 17px;
    margin-bottom: 14px;
    line-height: 24px;
  }
}

.steps-header.complete {
  padding-bottom: 13px;
}

small.complete-note {
  display: block;
  text-align: left;
  @include mq-down(md) {
    margin-top: 10px;
    margin-bottom: 0;
    line-height: 20px;
  }
  @include mq-up(md) {
    margin-top: 17px;
    margin-bottom: 14px;
    line-height: 24px;
  }
}
</style>
